import type { ApiQuestionSetting } from '../../../../internalTypes';

export type McqAnswerConditions = {
  minSelections?: number;
  maxSelections?: number;
  answerConditionErrorMessage?: string;
};

export function extractAnswerConditions(configs: ApiQuestionSetting[]): McqAnswerConditions {
  const conditionConfig = configs.find(c => c.key === 'ANSWER_CONDITION');
  if (conditionConfig?.value?.[0]?.toLowerCase() !== 'true') {
    return {};
  }

  const minMaxConfig = conditionConfig.childConfigs?.find(c => c.key === 'MIN_MAX_ANSWER');
  const minRaw = minMaxConfig?.childConfigs?.find(c => c.key === 'MIN_ANSWER')?.value?.[0];
  const maxRaw = minMaxConfig?.childConfigs?.find(c => c.key === 'MAX_ANSWER')?.value?.[0];
  const errorMessage = conditionConfig.childConfigs?.find(c => c.key === 'ERROR_MESSAGE')?.value?.[0];

  const minSelections = minRaw !== undefined ? Number(minRaw) : undefined;
  const maxSelections = maxRaw !== undefined ? Number(maxRaw) : undefined;

  return {
    ...(minSelections !== undefined && Number.isFinite(minSelections) ? { minSelections } : {}),
    ...(maxSelections !== undefined && Number.isFinite(maxSelections) ? { maxSelections } : {}),
    ...(errorMessage ? { answerConditionErrorMessage: errorMessage } : {}),
  };
}
